import {
  GET_RESTAURANT_INFO,
  GET_RESTAURANT_INFO_BY_ID,
  GET_RESTAURANT_ITEMS,
  RESET_INFO,
  RESET_ITEMS,
  SINGLE_ITEM,
  SEARCH_ITEM,
  CLEAR_SEARCH,
  SET_FAVORITE_REST,
  SET_MAPPED_REST,
  GET_RESTAURANT_INFO_FOR_LOGGED_IN_USER,
  GET_HOME_PRODUCTS,
  GET_SHOW_MORE_PRODUCTS,
  GET_PRICE_SORTED_PRODUCTS,
  GET_PRICE_SORTED_SHOW_MORE_PRODUCTS
} from "./actionTypes";
//RESET_BACKUP

import { FORCE_RELOAD } from "../helper/actionTypes";

import {
  GET_RESTAURANT_INFO_BY_ID_URL,
  GET_RESTAURANT_INFO_URL,
  GET_RESTAURANT_ITEMS_URL,
  GET_SINGLE_ITEM_URL,
  GET_RESTAURANT_INFO_AND_OPERATIONAL_STATUS_URL,
  ADD_TO_FAVORITE_RESTAURANT_URL,
  GET_FAVORITE_RESTAURANT_FOR_LOGGED_IN_URL,
  ADD_TO_MAPPED_RESTAURANT_URL,
  GET_HOME_PRODUCTS_URL,
  GET_SHOW_MORE_PRODUCTS_URL,
  GET_PRICE_SORTED_PRODUCTS_URL,
  GET_PRICE_SORTED_SHOW_MORE_PRODUCTS_URL,
  GET_ADDRESS_FROM_COORDINATES
} from "../../configs";
import { updateCart } from "../total/actions";

import Axios from "axios";
// import FuzzySearch from "fuzzy-search";
// import { WEBSITE_URL } from "../../configs/website";

export const setSingleItem = (product) => ({
  type: SINGLE_ITEM,
  payload: product,
});

export const getRestaurantInfoAndOperationalStatus = (
  id,
  latitude,
  longitude
) => (dispatch) => {
  return Axios.post(GET_RESTAURANT_INFO_AND_OPERATIONAL_STATUS_URL, {
    id: id,
    latitude: latitude,
    longitude: longitude,
  })
    .then((response) => {
      const restaurant_info = response.data;
      return dispatch({ type: GET_RESTAURANT_INFO, payload: restaurant_info });
    })
    .catch(function(error) {
      console.log(error);
      if (error.response.status === 400) {
        const force_reload = true;
        return dispatch({ type: FORCE_RELOAD, payload: force_reload });
      }
    });
};

export const getRestaurantInfo = (slug) => (dispatch, getState) => {
  let user = getState().user.user;
  let payload = {
    token: "",
    user_id: "",
  };
  if (user && user.data) {
    payload.token = user.data.auth_token;
    payload.user_id = user.data.id;
  }
  return Axios.post(GET_RESTAURANT_INFO_URL + "/" + slug, payload)
    .then((response) => {
      const restaurant_info = response.data;
      return dispatch({
        type: GET_RESTAURANT_INFO,
        payload: restaurant_info,
      });
    })
    .catch(function(error) {
      console.log(error);
    });
};

export const getRestaurantInfoForLoggedInUser = (slug) => (
  dispatch,
  getState
) => {
  return Axios.post(GET_FAVORITE_RESTAURANT_FOR_LOGGED_IN_URL + "/" + slug, {
    token: getState().user.user.data.auth_token,
    user_id: getState().user.user.data.id,
  })
    .then((response) => {
      const restaurant_info = response.data;
      return dispatch({
        type: GET_RESTAURANT_INFO_FOR_LOGGED_IN_USER,
        payload: restaurant_info,
      });
    })
    .catch(function(error) {
      console.log(error);
    });
};

export const getRestaurantInfoById = (id, lat, lng) => (dispatch, getState) => {
  return Axios.post(GET_RESTAURANT_INFO_BY_ID_URL + "/" + id, {
    latitude: lat,
    longitude: lng,
    user_id: getState().user.user.data.id,
  })
    .then((response) => {
      const restaurant_info = response.data;
      dispatch({
        type: GET_RESTAURANT_INFO_BY_ID,
        payload: restaurant_info,
      });
      return restaurant_info;
    })
    .catch(function(error) {
      console.log(error);
    });
};

export const getRestaurantItems = (slug) => (dispatch, getState) => {
  // Check if user exists and has auth data before using it
  const state = getState();
  const user = state.user && state.user.user ? state.user.user : null;
  
  // Prepare payload - handle cases where user is not logged in
  const payload = {};
  
  if (user && user.data && user.data.auth_token) {
    payload.token = user.data.auth_token;
    payload.user_id = user.data.id;
  }
  
  Axios.post(GET_RESTAURANT_ITEMS_URL + "/" + slug, payload)
    .then((response) => {
      const restaurant_items = response.data;

      Object.keys(restaurant_items.items).map((category, index) => {
        restaurant_items.items[category].map((item) => {
          item.desc = "";
        });
      });
      return dispatch({
        type: GET_RESTAURANT_ITEMS,
        payload: restaurant_items,
      });
    })
    .catch(function(error) {
      console.log(error);
    });
};

export const getSingleItem = (id) => (dispatch, getState) => {
  let user = getState().user.user;
  let payload = { token: "", user_id: "", id: id };
  if (user && user.data) {
    payload.token = user.data.auth_token;
    payload.user_id = user.data.id;
  }
  return Axios.post(GET_SINGLE_ITEM_URL, payload)
    .then((response) => {
      const item = response.data;
      // let itemDetails = {
      //   id: item.id,
      //   desc: "",
      //   recommended: [],
      //   compare_items: [],
      //   also_bought: [],
      // };
      // if (item.desc && item.id === itemDetails.id) {
      //   itemDetails = { desc: item.desc, id: item.id };
      //   item.desc = "";
      // }
      // if (
      //   item.recommended &&
      //   item.recommended.length &&
      //   item.id === itemDetails.id
      // ) {
      //   itemDetails.recommended = item.recommended;
      //   item.recommended = [];
      // }
      // if (
      //   item.compare_items &&
      //   item.compare_items.length &&
      //   item.id === itemDetails.id
      // ) {
      //   itemDetails.compare_items = item.compare_items;
      //   item.compare_items = [];
      // }
      // if (
      //   item.also_bought &&
      //   item.also_bought.length &&
      //   item.id === itemDetails.id
      // ) {
      //   itemDetails.also_bought = item.also_bought;
      //   item.also_bought = [];
      // }

      dispatch({
        type: SINGLE_ITEM,
        payload: item.id,
      });
      return item;
    })
    .catch(function(error) {
      console.log(error);
    });
};

export const resetItems = () => (dispatch) => {
  const empty = [];
  return dispatch({ type: RESET_ITEMS, payload: empty });
};
// export const resetBackup = () => (dispatch) => {
//   const empty = [];
//   return dispatch({ type: RESET_BACKUP, payload: empty });
// };

export const resetInfo = () => (dispatch) => {
  const empty = [];
  return dispatch({ type: RESET_INFO, payload: empty });
};

export const searchItem = (
  itemList,
  itemName,
  searchFoundText,
  noResultText
) => (dispatch, getState) => {
  const searchResultText = searchFoundText + itemName;
  const noSearchFoundText = noResultText + itemName;

  let foodItems = [];

  foodItems = itemList.filter((eachItem) => {
    const itemNames = eachItem.name.toLowerCase();
    return itemNames.includes(itemName.toLowerCase());
  });

  //console.log("searchResult", searchResult);

  // const searcher = new FuzzySearch(itemList, ["name"], {
  //   caseSensitive: false,
  // });

  //foodItems = searcher.search(itemName);

  if (foodItems.length > 0) {
    return dispatch({
      type: SEARCH_ITEM,
      payload: { items: { [searchResultText]: foodItems } },
    });
  } else if (foodItems.length <= 0) {
    return dispatch({
      type: SEARCH_ITEM,
      payload: { items: { [noSearchFoundText]: foodItems } },
    });
  }
};

export const sortItems = (itemList, selectedOption) => (dispatch) => {
  let store = [];
  if (selectedOption === "2") {
    store = itemList.sort(
      (a, b) => parseFloat(b.price.toString()) - parseFloat(a.price.toString())
    );
  } else if (selectedOption === "3") {
    store = itemList.sort(
      (a, b) => parseFloat(a.price.toString()) - parseFloat(b.price.toString())
    );
  }
  if (selectedOption === "2") {
    const highToLow = "Price - High to Low";
    return dispatch({
      type: SEARCH_ITEM,
      payload: { items: { [highToLow]: store } },
    });
  } else if (selectedOption === "3") {
    const lowToHigh = "Price - Low to High";
    return dispatch({
      type: SEARCH_ITEM,
      payload: { items: { [lowToHigh]: store } },
    });
  }
};

export const clearSearch = (data) => (dispatch) => {
  return dispatch({ type: CLEAR_SEARCH, payload: data });
};

export const setFavoriteRest = (token, rest_id, type) => (dispatch) => {
  return Axios.post(ADD_TO_FAVORITE_RESTAURANT_URL, {
    token: token,
    id: rest_id,
    type: type,
  })
    .then((response) => {
      const restaurant = response.data;
      if (type === "restaurant") {
        return dispatch({
          type: SET_FAVORITE_REST,
          payload: restaurant,
        });
      }
    })
    .catch(function(error) {
      console.log(error);
    });
};

export const mappedRestaurant = (token, rest_id, type) => (
  dispatch,
  getState
) => {
  return Axios.post(ADD_TO_MAPPED_RESTAURANT_URL, {
    token: token,
    action: type,
    restaurant_id: rest_id,
  })
    .then((response) => {
      const state = getState();
      // console.log(state);
      const cartProducts = state.cart.products;
      for (let i = cartProducts.length - 1; i >= 0; i--) {
        // remove all items from cart
        cartProducts.splice(i, 1);
      }

      dispatch(updateCart(cartProducts));

      const data = response;
      return dispatch({ type: SET_MAPPED_REST, payload: data });
    })
    .catch(function(error) {
      console.log(error);
    });
};

export const getHomeProducts = (latitude, longitude, state, appMode = 1) => {
  return async (dispatch) => {
    try {
      // console.log('🔥 API Call with App Mode:', `${GET_HOME_PRODUCTS_URL}?latitude=${latitude}&longitude=${longitude}&state=${state}&app_mode=${appMode}`);
      
      const response = await Axios.get(
        `${GET_HOME_PRODUCTS_URL}?latitude=${latitude}&longitude=${longitude}&state=${state}&app_mode=${appMode}`
      );
      
      // console.log('🔥 Raw API Response:', response.data);
      
      if (response.data && response.data.success && response.data.tagged_items) {
        // Validate and ensure exactly 6 items per tag
        const validateAndLimitItems = (items, tagName) => {
          if (!Array.isArray(items)) {
            console.warn(`⚠️ ${tagName} is not an array:`, items);
            return [];
          }
          
          // Take exactly 6 items and validate each one
          const validItems = items
            .slice(0, 6) // Strictly limit to 6
            .filter((item, index) => {
              const isValid = (
                item &&
                typeof item === 'object' &&
                typeof item.id === 'number' &&
                typeof item.name === 'string' &&
                typeof item.image === 'string' &&
                typeof item.price === 'number' &&
                item.name.trim() !== '' &&
                item.image.trim() !== ''
              );
              
              if (!isValid) {
                console.warn(`⚠️ Invalid item at index ${index} in ${tagName}:`, item);
              }
              
              return isValid;
            });
          
          // console.log(`✅ ${tagName}: ${validItems.length} valid items out of ${items.length} total`);
          return validItems;
        };

        const processedData = {
          ...response.data,
          tagged_items: {
            is_new: validateAndLimitItems(response.data.tagged_items.is_new || [], 'is_new'),
            is_top_picks: validateAndLimitItems(response.data.tagged_items.is_top_picks || [], 'is_top_picks'),
            is_popular: validateAndLimitItems(response.data.tagged_items.is_popular || [], 'is_popular')
          }
        };

        // console.log('🔥 Processed Data:', processedData);
        // console.log('🔥 Final counts:', {
        //   is_new: processedData.tagged_items.is_new.length,
        //   is_top_picks: processedData.tagged_items.is_top_picks.length,
        //   is_popular: processedData.tagged_items.is_popular.length
        // });

        dispatch({
          type: GET_HOME_PRODUCTS,
          payload: processedData
        });
      } else {
        // console.error('❌ Invalid API response structure:', response.data);
        dispatch({
          type: GET_HOME_PRODUCTS,
          payload: {
            success: false,
            master_items: [],
            tagged_items: {
              is_new: [],
              is_top_picks: [],
              is_popular: []
            }
          }
        });
      }
    } catch (error) {
      // console.error("❌ Error fetching home products:", error);
      dispatch({
        type: GET_HOME_PRODUCTS,
        payload: {
          success: false,
          master_items: [],
          tagged_items: {
            is_new: [],
            is_top_picks: [],
            is_popular: []
          }
        }
      });
    }
  };
};

export const getShowMoreProducts = (latitude, longitude, state, tag, page, limit = 6) => {
  return async (dispatch) => {
    try {
      // Build API URL using the configured endpoint
      const apiUrl = `${GET_SHOW_MORE_PRODUCTS_URL}?latitude=${latitude}&longitude=${longitude}&state=${state}&tag=${tag}&page=${page}&limit=${limit}`;
      
      // console.log('🔥 Show More API Call:', apiUrl);
      
      const response = await Axios.get(apiUrl);
      
      // console.log('🔥 Show More API Response:', response.data);
      
      if (response.data && response.data.success) {
        // Validate items from API response
        const validateItems = (items, tagName) => {
          if (!Array.isArray(items)) {
            console.warn(`⚠️ ${tagName} is not an array:`, items);
            return [];
          }
          
          const validItems = items.filter((item, index) => {
            const isValid = (
              item &&
              typeof item === 'object' &&
              typeof item.id === 'number' &&
              typeof item.name === 'string' &&
              typeof item.image === 'string' &&
              typeof item.price === 'number' &&
              item.name.trim() !== '' &&
              item.image.trim() !== ''
            );
            
            if (!isValid) {
              console.warn(`⚠️ Invalid show more item at index ${index} in ${tagName}:`, item);
            }
            
            return isValid;
          });
          
          // console.log(`✅ Show More ${tagName}: ${validItems.length} valid items out of ${items.length} total`);
          return validItems;
        };

        // Extract items for the specific tag - API returns items directly under the tag key
        const tagItems = response.data[tag] || [];
        const validatedItems = validateItems(tagItems, tag);

        // Since the API might return all items, we need to implement client-side pagination
        // Calculate the items for the requested page
        const startIndex = (page - 1) * limit;
        const endIndex = startIndex + limit;
        const paginatedItems = validatedItems.slice(startIndex, endIndex);

        // console.log(`🔥 Pagination: Page ${page}, Start: ${startIndex}, End: ${endIndex}`);
        // console.log(`🔥 Total items from API: ${validatedItems.length}, Paginated items: ${paginatedItems.length}`);

        const processedData = {
          success: true,
          tag: tag,
          page: page,
          items: paginatedItems,
          total_items: paginatedItems.length,
          total_available: validatedItems.length
        };

        // console.log('🔥 Show More Processed Data:', processedData);

        dispatch({
          type: GET_SHOW_MORE_PRODUCTS,
          payload: processedData
        });

        return processedData;
      } else {
        console.error('❌ Invalid Show More API response structure:', response.data);
        const errorData = {
          success: false,
          tag: tag,
          page: page,
          items: [],
          total_items: 0
        };
        
        dispatch({
          type: GET_SHOW_MORE_PRODUCTS,
          payload: errorData
        });

        return errorData;
      }
    } catch (error) {
      console.error("❌ Error fetching show more products:", error);
      const errorData = {
        success: false,
        tag: tag,
        page: page,
        items: [],
        total_items: 0,
        error: error.message
      };
      
      dispatch({
        type: GET_SHOW_MORE_PRODUCTS,
        payload: errorData
      });

      return errorData;
    }
  };
};

export const getPriceSortedProducts = (latitude, longitude, state, sortOrder = 'desc') => {
  return async (dispatch) => {
    try {
      // Handle clearing the data when null parameters are passed
      if (!latitude || !longitude || !state || !sortOrder) {
        // console.log('💰 Clearing price sorted data');
        dispatch({
          type: GET_PRICE_SORTED_PRODUCTS,
          payload: { 
            success: false, 
            master_items: [],
            tagged_items: { is_top_picks: [], is_new: [], is_popular: [] }
          }
        });
        return { 
          success: false, 
          master_items: [],
          tagged_items: { is_top_picks: [], is_new: [], is_popular: [] }
        };
      }

      const apiUrl = `${GET_PRICE_SORTED_PRODUCTS_URL}?latitude=${latitude}&longitude=${longitude}&state=${state}&sort_by=price&sort_order=${sortOrder}`;
      
      // console.log('💰 Price Sorted API Call:', apiUrl);
      
      const response = await Axios.get(apiUrl);
      
      // console.log('💰 Price Sorted API Response:', response.data);
      
      if (response.data && response.data.success && response.data.tagged_items) {
        // Validate tagged_items from API response
        const validateTaggedItems = (taggedItems) => {
          if (!taggedItems || typeof taggedItems !== 'object') {
            console.warn('⚠️ Tagged items is not an object:', taggedItems);
            return { is_top_picks: [], is_new: [], is_popular: [] };
          }
          
          const validatedTags = {};
          ['is_top_picks', 'is_new', 'is_popular'].forEach(tag => {
            const items = taggedItems[tag];
            if (!Array.isArray(items)) {
              console.warn(`⚠️ ${tag} is not an array:`, items);
              validatedTags[tag] = [];
            } else {
              const validItems = items.filter((item, index) => {
                const isValid = (
                  item &&
                  typeof item === 'object' &&
                  typeof item.id === 'number' &&
                  typeof item.name === 'string' &&
                  typeof item.image === 'string' &&
                  typeof item.price === 'number' &&
                  item.name.trim() !== '' &&
                  item.image.trim() !== ''
                );
                
                if (!isValid) {
                  console.warn(`⚠️ Invalid item in ${tag} at index ${index}:`, item);
                }
                
                return isValid;
              });
              
              // console.log(`✅ ${tag}: ${validItems.length} valid items out of ${items.length} total`);
              validatedTags[tag] = validItems;
            }
          });
          
          return validatedTags;
        };

        const validatedTaggedItems = validateTaggedItems(response.data.tagged_items);

        const processedData = {
          success: true,
          master_items: response.data.master_items || [],
          tagged_items: validatedTaggedItems,
          sort_by: response.data.sort_by || 'price',
          sort_order: response.data.sort_order || sortOrder,
          total_items: (response.data.master_items || []).length
        };

        // console.log('💰 Price Sorted Processed Data:', processedData);
        // console.log('💰 Tagged items breakdown:');
        // console.log('  - Top Picks:', processedData.tagged_items.is_top_picks.length, 'items');
        // console.log('  - New:', processedData.tagged_items.is_new.length, 'items');
        // console.log('  - Popular:', processedData.tagged_items.is_popular.length, 'items');

        dispatch({
          type: GET_PRICE_SORTED_PRODUCTS,
          payload: processedData
        });

        return processedData;
      } else {
        console.error('❌ Invalid Price Sorted API response structure:', response.data);
        const errorData = {
          success: false,
          master_items: [],
          tagged_items: { is_top_picks: [], is_new: [], is_popular: [] },
          sort_by: 'price',
          sort_order: sortOrder,
          total_items: 0,
          error: response.data.error || 'Unknown error'
        };
        
        dispatch({
          type: GET_PRICE_SORTED_PRODUCTS,
          payload: errorData
        });

        return errorData;
      }
    } catch (error) {
      console.error("❌ Error fetching price sorted products:", error);
      const errorData = {
        success: false,
        master_items: [],
        tagged_items: { is_top_picks: [], is_new: [], is_popular: [] },
        sort_by: 'price',
        sort_order: sortOrder,
        total_items: 0,
        error: error.message
      };
      
      dispatch({
        type: GET_PRICE_SORTED_PRODUCTS,
        payload: errorData
      });

      return errorData;
    }
  };
};

export const getPriceSortedShowMoreProducts = (latitude, longitude, state, tag, page, sortOrder, limit = 6) => {
  return async (dispatch) => {
    try {
      // Build API URL using the configured endpoint with price sorting parameters
      const apiUrl = `${GET_PRICE_SORTED_SHOW_MORE_PRODUCTS_URL}?latitude=${latitude}&longitude=${longitude}&state=${state}&tag=${tag}&sort_by=price&sort_order=${sortOrder}&page=${page}&limit=${limit}`;
      
      console.log('💰🔥 Price Sorted Show More API Call:', apiUrl);
      
      const response = await Axios.get(apiUrl);
      
      console.log('💰🔥 Price Sorted Show More API Response:', response.data);
      
      if (response.data && response.data.success) {
        // Validate items from API response - same validation as regular show more
        const validateItems = (items, tagName) => {
          if (!Array.isArray(items)) {
            console.warn(`⚠️ ${tagName} is not an array:`, items);
            return [];
          }
          
          const validItems = items.filter((item, index) => {
            const isValid = (
              item &&
              typeof item === 'object' &&
              typeof item.id === 'number' &&
              typeof item.name === 'string' &&
              typeof item.image === 'string' &&
              typeof item.price === 'number' &&
              item.name.trim() !== '' &&
              item.image.trim() !== ''
            );
            
            if (!isValid) {
              console.warn(`⚠️ Invalid price sorted show more item at index ${index} in ${tagName}:`, item);
            }
            
            return isValid;
          });
          
          console.log(`✅ Price Sorted Show More ${tagName}: ${validItems.length} valid items out of ${items.length} total`);
          return validItems;
        };

        // Extract items for the specific tag - API returns items directly under the tag key
        const tagItems = response.data[tag] || [];
        const validatedItems = validateItems(tagItems, tag);

        console.log(`💰🔥 Price Sorted Show More: Received ${validatedItems.length} total items from API for page ${page}`);

        // IMPORTANT: The API returns ALL items, but we need to implement client-side pagination
        // because the backend is not implementing proper pagination yet.
        // 
        // Page 1: Items 0-5 (handled by initial homeProducts call)
        // Page 2: Items 6-11 (this is what we want for first "Show More" click)
        // Page 3: Items 12-17 (for subsequent "Show More" clicks)
        
        const itemsToSkip = (page - 1) * limit; // For page 2: skip first 6 items (0-5)
        const paginatedItems = validatedItems.slice(itemsToSkip, itemsToSkip + limit);

        console.log(`💰🔥 Implementing client-side pagination:`);
        console.log(`  - Page: ${page}, Limit: ${limit}`);
        console.log(`  - Items to skip: ${itemsToSkip}`);
        console.log(`  - Taking items from index ${itemsToSkip} to ${itemsToSkip + limit - 1}`);
        console.log(`  - Returning ${paginatedItems.length} items out of ${validatedItems.length} total`);
        
        if (paginatedItems.length > 0) {
          console.log(`  - First item: ${paginatedItems[0].name} (ID: ${paginatedItems[0].id})`);
          console.log(`  - Last item: ${paginatedItems[paginatedItems.length - 1].name} (ID: ${paginatedItems[paginatedItems.length - 1].id})`);
        }

        const processedData = {
          success: true,
          tag: tag,
          page: page,
          items: paginatedItems, // Use paginated items, not all items
          total_items: paginatedItems.length,
          total_available: validatedItems.length,
          has_more: (itemsToSkip + limit) < validatedItems.length,
          sort_by: 'price',
          sort_order: sortOrder
        };

        console.log('💰🔥 Price Sorted Show More Processed Data:', processedData);

        dispatch({
          type: GET_PRICE_SORTED_SHOW_MORE_PRODUCTS,
          payload: processedData
        });

        return processedData;
      } else {
        console.error('❌ Invalid Price Sorted Show More API response structure:', response.data);
        const errorData = {
          success: false,
          tag: tag,
          page: page,
          items: [],
          total_items: 0,
          sort_by: 'price',
          sort_order: sortOrder
        };
        
        dispatch({
          type: GET_PRICE_SORTED_SHOW_MORE_PRODUCTS,
          payload: errorData
        });

        return errorData;
      }
    } catch (error) {
      console.error("❌ Error fetching price sorted show more products:", error);
      const errorData = {
        success: false,
        tag: tag,
        page: page,
        items: [],
        total_items: 0,
        sort_by: 'price',
        sort_order: sortOrder,
        error: error.message
      };
      
      dispatch({
        type: GET_PRICE_SORTED_SHOW_MORE_PRODUCTS,
        payload: errorData
      });

      return errorData;
    }
  };
};
